import { Beam } from "./Beam";
import { Crown } from "./Crown";
import { First } from "./First";
import { Logo } from "./Logo";
import { Second } from "./Second";
import { Third } from "./Third";

export const SubscriptionCard = () => {
  return (
    <div className="relative">
      <div className="absolute left-0 top-0">
        <First />
      </div>
      <div className="absolute left-0 top-0">
        <Second />
      </div>
      <div className="absolute left-0 top-0">
        <Third />
      </div>
      <div className="absolute left-1/2 top-8 -translate-x-1/2">
        <Crown />
      </div>
      <div className="absolute left-[150px] top-2 opacity-60">
        <Beam />
      </div>
      <div className="absolute left-4 top-4 opacity-[47%]">
        <Logo />
      </div>
    </div>
  );
};
